import React from "react";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import { Image } from "react-bootstrap";
import companyIcon from "../../../images/office.png"; // Using placeholder image
import moment from "moment";
import pic1 from "../../../images/comapny/icon_engineering.png";
import pic2 from "../../../images/comapny/icon_banking.png";
import pic3 from "../../../images/comapny/icon_gov.png";
import pic4 from "../../../images/comapny/icon_teaching.png";
import pic5 from "../../../images/comapny/icon_technology.png";
import pic6 from "../../../images/comapny/icon_railway.png";
import pic7 from "../../../images/comapny/icon_defence.png";
import pic8 from "../../../images/comapny/icon_gov.png";
import pic9 from "../../../images/comapny/icon_acc.png";
import pic10 from "../../../images/comapny/icon_gpsc.png";
import pic11 from "../../../images/comapny/icon_police.png";
import pic12 from "../../../images/comapny/icon_upsc.png";
import pic13 from "../../../images/comapny/icon_hr.png";
import pic14 from "../../../images/comapny/icon_sales.png";
import pic15 from "../../../images/comapny/icon_marketing.png";
import pic16 from "../../../images/comapny/icon_finance.png";
import pic17 from "../../../images/comapny/icon_operations.png";
import pic18 from "../../../images/comapny/icon_customer_service.png";
import pic19 from "../../../images/comapny/icon_embedded.png";
import pic20 from "../../../images/comapny/icon_ai_ml.png";

const getProfilePictureUrl = (profilePicture) => {
  if (!profilePicture) return companyIcon;
  return profilePicture;
};

const maskEmail = (email) => {
  if (!email) return "N/A";
  // const [localPart, domainPart] = email.split("@");
  // return `${localPart.slice(0, 1)}${"*".repeat(
  //   localPart.length - 1
  // )}@${domainPart}`;
  return email;
};

const maskPhoneNumber = (phoneNumber) => {
  if (!phoneNumber) return "N/A";
  return `${"*".repeat(8)}${phoneNumber.slice(-2)}`;
};

const categoryImages = {
  1: pic1,
  2: pic2,
  3: pic3,
  4: pic4,
  5: pic5,
  6: pic6,
  7: pic7,
  8: pic8,
  9: pic9,
  10: pic10,
  11: pic11,
  12: pic12,
  13: pic13,
  14: pic14,
  15: pic15,
  16: pic16,
  17: pic17,
  18: pic18,
  19: pic19,
  20: pic20,
};
const CompanyCard = ({ company, handleImageError }) => {
  //   console.log(company);
  return (
    <div className="col-xl-6">
      <div className="jobs2 card">
        <div className="card-body d-flex flex-column justify-content-between">
          <div className="d-flex align-items-center">
            <Image
              src={categoryImages[company.job_category_id]}
              alt={company.company_name}
              className="me-3"
              width="60"
              height="60"
              onError={() => handleImageError(company.company_id)}
              style={{ objectFit: "cover" }}
            />
            <div>
              <h4 className="fs-20 mb-1">{company.company_name}</h4>
              {company.job_location && (
                <p className="fs-14 mb-2">
                  <i className="fas fa-map-marker-alt me-2"></i>
                  {company.job_location}
                </p>
              )}
            </div>
          </div>
          <div className="mt-3 d-flex justify-content-between">
            <div style={{ width: "100%" }}>
              {company.company_address && (
                <p className="fs-14 mb-2">
                  <i className="fas fa-map-marker-alt me-2"></i>
                  {company.company_address}
                </p>
              )}
              <p className="fs-14 mb-2">
                <i className="fas fa-envelope me-2"></i>
                {maskEmail(company.company_email)}
              </p>
              {company.company_contact_no && (
                <p className="fs-14 mb-0">
                  <i className="fas fa-phone me-2"></i>
                  {maskPhoneNumber(company.company_contact_no)}
                </p>
              )}
            </div>
            {/* <div
              className="d-flex justify-content-end align-self-end"
              style={{ width: "40%" }}
            >
              <div>
                <span
                  style={{
                    padding: "5px 10px",
                    borderRadius: "4px",
                    color: "#fff",
                  }}
                  className="font-weight-bold d-block bg-danger"
                >
                  Last Job Posted:{" "}
                  {company.created_at
                    ? moment(company.created_at).format("DD-MM-YYYY")
                    : "N/A"}
                </span>
              </div>
            </div> */}
          </div>
          <div className="d-flex justify-content-between mt-3">
            <Button
              as={Link}
              to={`/company-view/${company.company_id}`}
              variant="primary"
              size="sm"
            >
              View Details
            </Button>
            {/* <Button
              variant="secondary"
              size="sm"
              onClick={() => handleRequestCampusDrive(company)}
            >
              Request For Campus Drive
            </Button> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyCard;
